/*
 *
 * File JS componente timeline slider
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import Swiper from "swiper/bundle";
//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./timeline-slider.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const timelineSlider = () => {
    let allTimelineSlider = document.querySelectorAll(".timeline-slider");

    if (!allTimelineSlider.length) return;

    allTimelineSlider.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            breakpoints: {
                0: { spaceBetween: 8, slidesPerView: 3 },

                500: { spaceBetween: 8, slidesPerView: 3 },

                768: { spaceBetween: 8, slidesPerView: 5 },

                860: { spaceBetween: 24, slidesPerView: 5 },

                1128: { spaceBetween: 24, slidesPerView: 7 },

                1330: { spaceBetween: 30, slidesPerView: 9 },
            },
            spaceBetween: 30,
            // centeredSlides: true,
            initialSlide: $slide_index,
            // loop: true,
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                dynamicBullets: true,
                clickable: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default timelineSlider;

//--------------------------------------------------------------------//
